import { render } from "./xt_spacer.vue?vue&type=template&id=28ce4764&scoped=true"
import script from "./xt_spacer.vue?vue&type=script&lang=js"
export * from "./xt_spacer.vue?vue&type=script&lang=js"

import "./xt_spacer.vue?vue&type=style&index=0&id=28ce4764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ce4764"]])

export default __exports__